'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = containsEvent;
function containsEvent(events, event) {
  if (typeof events === 'string') {
    return events === event;
  }

  return !!~events.indexOf(event);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/utils/contains-event.js
// module id = 1265
// module chunks = 0